import React from 'react'
import { useNewsList, NewsListProps } from './useNewsList'
import styles from './NewsList.module.scss'
import FilterController from './FilterController/FilterController'
import List from './List/List'
import LoadMore from './LoadMore/LoadMore'

const NewsList: React.FC<NewsListProps> = (props: NewsListProps) => {
  const {
    searchTerm,
    selectedCategory,
    selectedTag,
    paginatedNewsData,
    newsCount,
    newsCategories,
    newsTags,
    isLoading,
    isAr,
    t,
    setSearchTerm,
    setSelectedCategory,
    setSelectedTag,
    handleLoadMore,
    handleSearch,
    handleKeyDown,
  } = useNewsList(props)

  return (
    <section className={styles['news-listing']}>
      <div className='container pt-5'>
        <FilterController
          searchTerm={searchTerm}
          selectedCategory={selectedCategory}
          selectedTag={selectedTag}
          newsCategories={newsCategories}
          newsTags={newsTags}
          isLoading={isLoading}
          isAr={isAr}
          t={t}
          setSearchTerm={setSearchTerm}
          setSelectedCategory={setSelectedCategory}
          setSelectedTag={setSelectedTag}
          handleSearch={handleSearch}
          handleKeyDown={handleKeyDown}
        />
        <List news={paginatedNewsData} isAr={isAr} t={t} />
        <LoadMore
          news={paginatedNewsData}
          newsCount={newsCount}
          isLoading={isLoading}
          handleLoadMore={handleLoadMore}
          t={t}
        />
      </div>
    </section>
  )
}

export default NewsList
